import CorporateInvoiceExport from "./corporateInvoiceExport.service";

const corporateInvoiceExportModule = angular
  .module("app.services.corporateInvoiceExport", [])
  .service("CorporateInvoiceExport", CorporateInvoiceExport);

export default corporateInvoiceExportModule;



// WEBPACK FOOTER //
// ./src/services/corporateInvoiceExport/corporateInvoiceExport.module.js